import axios from "axios";

const env = process.env.NODE_ENV;

const API_URL =
  env === "development"
    ? "http://localhost:3001" //development
    : "https://questionnaire-backend.uc.r.appspot.com"; // production

async function addResponses(responses) {
  try {
    const { data: newResponses } = await axios.post(API_URL + "/postResponses", {
      responses,
    });
    console.log("env:" + env);
    return newResponses;
  } catch (error) {
    console.warn("Failed to save responses:", error.message);
    return null;
  }
}

async function deleteResponse(id) {
  const message = await axios.delete(`${API_URL}"/deleteResponse/"${id}`);
  return message;
}

async function updateResponse(id, payload) {
  const { data: newResponse } = await axios.put(
    `${API_URL}"/updateResponse/"${id}`,
    payload
  );
  return newResponse;
}

async function getAllResponses() {
  try {
    const { data: responses } = await axios.get(API_URL + "/getResponses");
    return responses;
  } catch (error) {
    console.warn("Failed to fetch responses:", error.message);
    return [];
  }
}


const APIHelper = {
  addResponses,
  deleteResponse,
  updateResponse,
  getAllResponses,
};

export default APIHelper;
